import React from 'react';
import LazyImage from './lazyLoad';

const NoItemFound = ({ img, header, subHeader, children }) => {
  return (
    <div className='d-flex flex-column align-items-center'>
      <div className='d-flex justify-content-center align-items-center p-5 flex-column'>
        <LazyImage height={151} width={249} src={img} alt='Not found' />
        <div className='fs-20 fw-700 appSubHeader text-align-center'>{header}</div>
        <div className='fs-12 fw-400 text-center appSubHeader'>{subHeader}</div>
      </div>
      {children && children}
    </div>
  );
};

export default NoItemFound;
